// extracted by mini-css-extract-plugin
module.exports = {"organizations":"ob_QynvZq","organization":"ob_jcaAif","rightIcon":"ob_JaCJtC"};